// extracted by mini-css-extract-plugin
export var brand = "_q-9";
export var button = "_q-0";
export var chevron = "_q-v";
export var chevronButton = "_q-w";
export var content = "_q-n";
export var danger = "_q-g";
export var dangerOutlined = "_q-h";
export var dark = "_q-l";
export var darkTheme = "_q-c";
export var extraSmall = "_q-4";
export var fullWidth = "_q-8";
export var ghost = "_q-d";
export var gray = "_q-t";
export var icon = "_q-p";
export var iconButton = "_q-s";
export var iconButtonBorder = "_q-x";
export var iconButtonBorderDark = "_q-y";
export var iconButtonBorderLight = "_q-z";
export var iconLeft = "_q-q";
export var iconRight = "_q-r";
export var large = "_q-1";
export var light = "_q-m";
export var medium = "_q-2";
export var micro = "_q-5";
export var nano = "_q-7";
export var outlined = "_q-k";
export var pending = "_q-a";
export var primary = "_q-i";
export var shadow = "_q-o";
export var small = "_q-3";
export var solidLight = "_q-e";
export var solidLightBrand = "_q-f";
export var spinner = "_q-u";
export var transparent = "_q-j";
export var warning = "_q-b";
export var wideNano = "_q-6";